"use strict";

exports.__esModule = true;
exports.bundle = exports.getStats = exports.parseBundle = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _jsonTree = require("./json-tree");

var _jsonTree2 = _interopRequireDefault(_jsonTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseBundle = exports.parseBundle = function parseBundle(bundles) {
  return bundles ? bundles && bundles[0] : null;
};

var getStats = exports.getStats = function getStats(bundles) {
  if (Array.isArray(bundles)) {
    return parseBundle(bundles);
  } else {
    throw new Error("**** Pass the stats.json as per instructions electrify -h ****");
  }
};

var bundle = exports.bundle = function bundle(bundles, opts, callback) {
  if (typeof opts === "function") {
    callback = opts;
    opts = {};
  }
  opts = opts || {};
  callback = callback || function () {};

  var data = {};
  data.mode = opts.mode || "size";
  data = (0, _stringify2.default)((0, _jsonTree2.default)(getStats([bundles])));
  return callback(null, { data: data });
};


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/helpers/modules-helpers/parsing-utils.js
// module id = 620
// module chunks = 0